module.exports = "/_next/static/images/bca-aaf17b58599e214f670faa5144abb3ee.svg";